import { render, staticRenderFns } from "./formConfig.vue?vue&type=template&id=c9ceaa70"
import script from "./formConfig.vue?vue&type=script&lang=js"
export * from "./formConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports